module.exports = __webpack_public_path__ + "static/media/fly0022.d45a7040.webp";